<template>
  <div class="pass-list">
    <div class="passenger-info no-padding" v-for="(pass, idx) in passengers" :key="idx">
      <div class="form-title" style="width: 55px; position: relative">
        <div class="no-index">{{ idx + 1 }}</div>
      </div>
      <div style="width: 100%; position: relative; border-right: 1px dashed #aaaaaa; padding: 10px">
        <el-form class="passenger-input-info" style="margin-top: 10px" label-position="top">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <el-input placeholder="请输入英文姓（如Li）" v-model="pass.firstName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-input placeholder="请输入英文名（如SANSAN）" v-model="pass.lastName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <el-select placeholder="请选择证件类型" style="width: 100%" v-model="pass.certType" >
                  <template slot="prefix">
                    <div style="display: flex; align-items: center; height: 100%">
                      <img :src="require('@/assets/icon-tip.png')" style="width: 20px; height: 20px" @click="showFillModal($event)" />
                    </div>
                  </template>
                  <el-option :value="n.code" :label="n.text" :key="n.code" v-for="n in certTypeList">{{ n.text }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-input v-model="pass.certNo" placeholder="请输入证件号码"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" :key="pass.index">
            <el-col :span="12">
              <el-form-item>
                <el-select style="width: 100%" v-model="pass.gender">
                  <el-option value="M" label="先生">先生</el-option>
                  <el-option value="F" label="女士">女士</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-date-picker style="width: 100%" v-model="pass.birthday" placeholder="出生日期" value-format="yyyy-MM-dd" @change="birthdayChange(pass)"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <el-select style="width: 100%" filterable v-model="pass.certIssuePlace" placeholder="请选择签发国家">
                  <el-option-group v-for="group in nationalityList" :key="group.letter" :label="group.letter">
                    <el-option v-for="item in group.children" :key="item.code" :label="item.name" :value="item.code"></el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-select style="width: 100%" filterable v-model="pass.nationality" placeholder="请选择国籍">
                  <el-option-group v-for="group in nationalityList" :key="group.letter" :label="group.letter">
                    <el-option v-for="item in group.children" :key="item.code" :label="item.name" :value="item.code"></el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <el-date-picker style="width: 100%" v-model="pass.certExpired" placeholder="证件有效期" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item>
                <el-input v-model="pass.mobile" placeholder="请输入手机号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="per-passenger-wrapper">
        <div style="position: absolute; top: 10px; right: 10px; cursor: pointer;">
          <span @click="delPass(pass, idx)">
            <i class="el-icon-delete"></i>
          </span>
        </div>
        <div class="per-passenger-count">
          <img style="width: 32px; height: 32px" src="@/assets/adult.png" alt="" />
          <span style="font-size: 20px; color: #d70039">¥{{ pass.priceInfo && pass.priceInfo.totalAmount }} {{ pass.type | formatPassType }}</span>
        </div>
      </div>
    </div>
    <div class="add-wrapper" v-if="passengers.length < maxCount">
      <button class="add-passenger" @click="addPass()">
        <i class="el-icon-plus"></i>
        添加乘机人
      </button>
    </div>
    <el-dialog title="证件填写说明" :visible.sync="fillModal">
      <div v-html="fillInstructions" style="max-height: 400px; line-height: 25px; overflow-y: scroll; overflow-x: hidden"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="fillModal = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryDict, getCountryCodes } from "@/api/newsapi";
import { MessageBox, Message } from "element-ui";
import { getPassType } from '@/utils/index.js'
import { defaultPassInfo, passTypeMap, intCertTypeList } from '../config.js'

export default {
  props: {
    passengers: {
      type: Array,
      default: () => []
    },
    maxCount: {
      type: Number,
      default: 9
    },
    depFlightDate: {
      type: String,
      default: ""
    },
    product: {
      type: Object,
      default: () => ({})
    },
    searchFilter: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      fillModal: false,
      fillInstructions: '',
      certTypeList: [ ...intCertTypeList ],
      nationalityList: []
    };
  },


  filters: {
    formatPassType(passType) {
      return passTypeMap[passType] || '';
    }
  },

  mounted() {
    this._getNationalityList();
    this._getCertFillDes();
  },

  methods: {
    _getNationalityList() {
      getCountryCodes().then(res => {
        if (res.success) {
          let data = [];
          res.data.map(s => {
            data.push(...s.children);
          });
          this.nationalityList = res.data;
        }
      });
    },
    _getCertFillDes() {
      queryDict({ key: "CERT_FILL_INSTRUCTIONS" }).then(res => {
        if (res.success) {
          this.fillInstructions = (res.data || "").replace(/\\n/g, "<br/>");
        }
      });
    },
    addPass() {
      if(this.passengers.length >= this.maxCount) {
        this.$message.warning(`最多添加${ this.maxCount }位乘机人`)
        return
      }

      this.passengers.push(Object.assign({}, defaultPassInfo))
    },
    delPass(pass, idx) {
      if(this.passengers.length <= 1) {
        this.$message.warning('至少保留一位乘机人')
        return
      }
      this.passengers.splice(idx, 1);
      if(pass.id) this.$emit('delete', pass.id);
    },
    showFillModal(e) {
      e.stopPropagation();
      this.fillModal = true;
    },
    birthdayChange(pass) {
      const passType = getPassType(pass.birthday, this.depFlightDate);
      if(passType == 'INF') {
        this.infNoticeShow(pass)
        return;
      }
      if(passType == 'CHD' && !this.searchFilter.carryChild) {
        this.childNoticeShow();
        // return;
      }
      const priceInfo = this.getShowPrice(passType);
      this.$set(pass, 'type', passType);
      this.$set(pass, 'priceInfo', priceInfo);
    },
    getShowPrice(passType) {
      const passengerPrice = this.product.passengerPrice || [];
      const priceInfo = passengerPrice.find(item => item.passengerType == passType);
      return priceInfo || passengerPrice?.[0] || {}
    },

    childNoticeShow(cancelHandler) {
      MessageBox.confirm("因您在搜索机票时未选儿童，系统将自动为您重新查询，是否前往航班列表选择航班？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "m-message-box"
      }).then(() => {
        const query = { 
          deptAirportCode: this.searchFilter.depAirport, 
          arrAirportCode: this.searchFilter.arrAirport, 
          deptDate: this.searchFilter.depDate, 
          retDate: this.searchFilter.returnDate, 
          switch: this.searchFilter.tripType, 
          normalBooking: true, 
          carryChild: 1 
        }
        this.$router.push({path: '/ticket', query: { ...query }})
      }).catch(() => {
        console.log('cancel');
        (cancelHandler && typeof cancelHandler == 'function') && cancelHandler();
      })
    },
    infNoticeShow(pass) {
      MessageBox.confirm("暂不支持婴儿，仅支持成人和2 ~ 12岁儿童，请重新选择出生日期。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: false,
        type: "warning",
        customClass: "m-message-box"
      }).then(() => {
        this.$set(pass, 'birthday', '');
      })
    },

    // 父级通过refs在调用
    validNewPassenger(pass, cancelHandler) {
      const passType = getPassType(pass.birthday, this.depFlightDate);
      if(passType == 'CHD' && !this.searchFilter.carryChild) {
        this.childNoticeShow(cancelHandler);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.no-padding {
  padding: 0 !important;
}
.no-border {
  border: 0 !important;
}
.pass-list {
  .passenger-info {
    margin-bottom: 16px;
    background-color: #fff;
    padding: 8px 0;
    // padding-left: 5%;
    border: 1px solid #eae7e7;
    display: flex;
    border-radius: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    .form-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .form-title div:first-child {
      font-size: 14px;
      font-weight: 700;
      line-height: 1.5;
      color: #b2b2b2;
      text-align: left;
    }

    .form-title div:nth-child(2) {
      margin: 0 4px;
      font-size: 12px;
      font-weight: 400;
      line-height: 1.5;
      color: #9d9d9d;
      text-align: center;
      cursor: pointer;
    }
    .no-index {
      font-size: 40px !important;
      position: absolute;
      top: 0;
      left: 10px;
      font-style: italic;
      font-weight: 200 !important;
    }
    .passenger-input-info .el-form-item__label {
      padding-bottom: 0;
    }

    .passenger-input-info .el-form-item {
      margin-bottom: 10px;
    }

    .passenger-input-info .el-input__inner {
      border-radius: 0 !important;
    }

    .per-passenger-wrapper {
      position: relative;
      width: 200px;
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      .per-passenger-count {
        display: flex;
        align-items: center;
      }
    }
  }
}


.add-wrapper {
  display: flex;
  align-items: center;
}

.add-passenger {
  margin-right: 10px;
  background-color: #ffffff;
  width: 163px;
  height: 43px;
  color: #d70039;
  border: 1px solid #d70039;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}

.add-passenger:active {
  background-color: #d70039;
  border-color: #d70039;
  color: #fff;
}
</style>
